import { api } from './client';

export type EstadoDian =
  | 'pendiente'
  | 'enviado'
  | 'aprobado'
  | 'aprobado_notificacion'
  | 'rechazado'
  | 'error';

export interface Venta {
  id: number;
  sede_id: number;
  sede_codigo: string;
  sede_nombre: string;
  entidad_legal_id: number;
  nit: string;
  razon_social: string;
  prefijo: string;
  folio: number;
  fecha_emision: string;     // YYYY-MM-DD
  hora_emision: string;      // HH:MM:SS
  cierre_at: string;         // ISO datetime
  num_personas: number | null;
  num_articulos: number;
  // desglose POS
  subtotal_alimentos: string;
  subtotal_bebidas: string;
  subtotal_otros: string;
  descuentos_cortesias: string;
  // impuestos
  inc_base: string;
  inc_valor: string;
  iva_valor: string;
  ica_valor: string;
  rete_iva: string;
  rete_renta: string;
  rete_ica: string;
  // totales
  subtotal: string;
  cargo: string;
  total_sin_propina: string;
  propina: string;
  total: string;
  // DIAN
  forma_pago_dian: string;
  medio_pago_dian: string | null;
  cufe: string | null;
  estado_dian: EstadoDian;
  estado_dian_msg: string | null;
  // conciliación
  inc_diff_redondeo: string;
  conciliada: boolean;
  // cliente
  cliente_nombre: string | null;
  cliente_identificacion: string | null;
  cliente_tipo_documento?: string | null;   // '13'=CC, '31'=NIT, '22'=CE…
  // derivados
  num_pagadores?: number | string | null;    // # de pagos (no personas de mesa)
  autorizacion_redeban?: string | null;       // auth del voucher datáfono (Redeban)
}

export interface VentasFilter {
  desde?: string;
  hasta?: string;
  sede_id?: number;
  entidad_legal_id?: number;
  estado_dian?: EstadoDian;
  limit?: number;
  offset?: number;
}

export async function fetchVentas(f: VentasFilter = {}): Promise<{ data: Venta[]; limit: number; offset: number }> {
  const qs = new URLSearchParams();
  Object.entries(f).forEach(([k, v]) => v !== undefined && v !== null && qs.set(k, String(v)));
  // El backend ahora devuelve array directo. Adaptamos a la forma esperada
  // por los componentes que ya usan `.data`.
  const data = await api.get<Venta[]>(`/api/ventas?${qs.toString()}`);
  return { data, limit: f.limit ?? data.length, offset: f.offset ?? 0 };
}

export const fetchVenta = (id: number) => api.get<Venta & { items: any[]; pagos: any[] }>(`/api/ventas/${id}`);

// Resuelve el id de una venta por su número (prefijo + folio), p.ej. PWY + 1.
export async function fetchVentaIdByRef(prefijo: string, folio: number | string): Promise<number> {
  const r = await api.get<{ id: number }>(`/api/ventas/by-ref?prefijo=${encodeURIComponent(prefijo)}&folio=${folio}`);
  return r.id;
}

// Cuadre de caja: suma de los PAGOS REALES (ventas_pagos) de una fecha,
// agrupados por medio de pago. Refleja pagos divididos (no usa el único
// v.medio_pago_dian, que puede ser null).
export interface CuadrePagos { efectivo: number; datafono: number; qr: number; total: number; }
export async function fetchCuadrePagos(sede_id: number, fecha: string): Promise<CuadrePagos> {
  const r = await api.get<{ data: CuadrePagos }>(`/api/ventas/cuadre-pagos?sede_id=${sede_id}&fecha=${fecha}`);
  return r.data;
}

// Helpers numéricos: la API devuelve strings (NUMERIC pg). Convertimos a number cuando se necesita.
export const num = (v: string | number | null | undefined): number => (v == null ? 0 : Number(v));
